@switch (design) {
  @case ('col2') {
    <div class="col-2-design">
      <ng-container>
        <ng-content select="[col1]" />
      </ng-container>
      <ng-container>
        <ng-content select="[col2]" />
      </ng-container>
    </div>
  }
  @case ('box') {
    <mat-card class="box-design">
      <mat-card-content class="content">
        <ng-container *ngTemplateOutlet="defaultContent" />
      </mat-card-content>
    </mat-card>
  }
  @default {
    <ng-container *ngTemplateOutlet="defaultContent" />
  }
}

<ng-template #defaultContent>
  <ng-content />
</ng-template>
